<template>
  <span class="bid-modifiers-badge">
    <span
      v-if="registrationBidModifiers"
      class="badge badge-bid-registration"
    >
      {{ registrationBidModifiers.minMarginPercent }}% - {{ registrationBidModifiers.maxMarginPercent }}%
    </span>
    <span
      v-else-if="offerBidModifiers"
      class="badge badge-bid-offer"
    >
      <template v-if="showOfferPrefix">offer </template>{{ offerBidModifiers.minMarginPercent }}% - {{ offerBidModifiers.maxMarginPercent }}%
    </span>
    <span
      v-else-if="categoryBidModifiers"
      class="badge badge-bid-category"
    >
      <template v-if="showCategoryPrefix">category </template>{{ categoryBidModifiers.minMarginPercent }}% - {{ categoryBidModifiers.maxMarginPercent }}%
    </span>
    <span
      v-else
      class="badge badge-bid-notset"
    >
      Not set
    </span>
    <br v-if="hasStateOverrides">
    <span
      v-if="hasStateOverrides"
      class="badge badge-state-overrides"
      :class="stateOverridesBgClass"
    >
      states override
    </span>
    <br v-if="minProfitAmount != null">
    <span
      v-if="minProfitAmount != null"
      class="badge badge-min-profit"
    >
      min profit ${{ minProfitAmount }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'BidModifiersBadge',

  props: {
    registration: {
      type: Object,
      default: null
    },
    offer: {
      type: Object,
      default: null
    },
    category: {
      type: Object,
      default: null
    },
    showOfferPrefix: {
      type: Boolean,
      default: false
    },
    showCategoryPrefix: {
      type: Boolean,
      default: true
    },
    minProfitAmount: {
      type: Number,
      default: null
    }
  },

  computed: {
    registrationBidModifiers() {
      if (this.registration?.useBidModifiers) {
        return this.registration
      }

      return null
    },

    offerBidModifiers() {
      if (this.offer?.useBidModifiers) {
        return this.offer
      }

      return null
    },

    categoryBidModifiers() {
      if (this.category?.minMarginPercent != null && this.category?.maxMarginPercent != null) {
        return this.category
      }

      return null
    },

    activeBidModifiers() {
      return this.registrationBidModifiers || this.offerBidModifiers || this.categoryBidModifiers
    },

    stateOverridesBgClass() {
      if (this.registrationBidModifiers) {
return 'bg-registration'
}

      if (this.offerBidModifiers) {
return 'bg-offer'
}

      return 'bg-category'
    },

    hasStateOverrides() {
      const overrides = this.activeBidModifiers?.stateMarginOverrides
      if (!overrides) {
return false
}

      if (Array.isArray(overrides)) {
return overrides.length > 0
}

      return Object.keys(overrides).length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.badge-bid-registration {
  background-color: rgba(32, 107, 196, 0.08);
  color: #6a9fd4;
}

.badge-bid-offer {
  background-color: rgba(40, 167, 69, 0.08);
  color: #5a9e6a;
}

.badge-bid-category {
  background-color: rgba(255, 152, 0, 0.1);
  color: #c77c00;
}

.badge-bid-notset {
  background-color: rgba(220, 53, 69, 0.08);
  color: #d08088;
}

.badge-min-profit {
  background-color: rgba(255, 152, 0, 0.1);
  color: #c77c00;
}

.badge-state-overrides {
  color: rgba(220, 53, 69, 0.55);

  &.bg-registration {
    background-color: rgba(32, 107, 196, 0.08);
  }

  &.bg-offer {
    background-color: rgba(40, 167, 69, 0.08);
  }

  &.bg-category {
    background-color: rgba(255, 152, 0, 0.1);
  }
}
</style>
